var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5615_4052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 28.125C11.519 28.125 8.18064 26.7422 5.71922 24.2808C3.25781 21.8194 1.875 18.481 1.875 15C1.875 11.519 3.25781 8.18064 5.71922 5.71922C8.18064 3.25781 11.519 1.875 15 1.875C18.481 1.875 21.8194 3.25781 24.2808 5.71922C26.7422 8.18064 28.125 11.519 28.125 15C28.125 18.481 26.7422 21.8194 24.2808 24.2808C21.8194 26.7422 18.481 28.125 15 28.125ZM15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30Z",
    fill: "#10B029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5691 9.31964L20.5316 9.36089L14.0198 17.6578L10.0954 13.7315C9.82881 13.4831 9.47623 13.3479 9.11191 13.3543C8.7476 13.3607 8.4 13.5083 8.14235 13.766C7.8847 14.0236 7.73712 14.3712 7.73069 14.7355C7.72426 15.0999 7.85949 15.4524 8.10789 15.719L13.0691 20.6821C13.2028 20.8156 13.3619 20.9207 13.5371 20.9912C13.7123 21.0618 13.8999 21.0964 14.0887 21.0929C14.2775 21.0894 14.4636 21.0479 14.6361 20.9709C14.8085 20.8939 14.9636 20.7829 15.0923 20.6446L22.5773 11.2884C22.8321 11.0209 22.9715 10.6638 22.9652 10.2944C22.9589 9.92497 22.8075 9.57286 22.5436 9.31419C22.2798 9.05553 21.9247 8.9111 21.5553 8.91211C21.1858 8.91313 20.8315 9.05953 20.5691 9.31964Z",
    fill: "#10B029"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5615_4052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.afaab055511190bfeed4479bf36690b8.svg";
export { ForwardRef as ReactComponent };